import "./style.css";

export const BtnBack = (props) => {
	const { isSubmitting, onClick, additionalClasses = "" } = props;

	return (
		<button
			type="button"
			onClick={(event) => onClick(event)}
			className={`btn btn-primary btn-back ${additionalClasses}`}
			disabled={isSubmitting}
		>
			Voltar
		</button>
	);
};
